import React from 'react';

const TableHeader = () => {
  return (
    <thead>
      <tr>
        <th data-field='date'>
          Date
        </th>
        <th data-field='type'>
          Type
        </th>
        <th data-field='sent-quantity'>
          Sent Quantity
        </th>
        <th data-field='received-quantity'>
          Received Quantity
        </th>
        <th data-field='source'>
          Source
        </th>
        <th data-field='transaction-id'>
          Transaction ID
        </th>
        <th data-field='Counterparty'>
          Counterparty
        </th>
        <th data-field='status'>
        </th>
      </tr>
    </thead>
  )
}

export default TableHeader;